import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { Observable, ReplaySubject } from 'rxjs';

/**
 * Service for managing backdrops.
 */
@Injectable({ providedIn: 'root' })
export class BackdropService {
    public backdropStream: Observable<boolean>;
    private _backdropSubject = new ReplaySubject<boolean>(1);
    private _isBehindContent: boolean;
    private _isWhite: boolean;
    private _closeOnClick: boolean;
    private _animate: boolean;
    private _isOpen: boolean;
    private _onClick: () => void;

    constructor() {
        SingletonServiceGuard.register('BackdropService');
        this.backdropStream = this._backdropSubject.asObservable();
    }

    public openBackdrop(options?: {
        onClick?: () => void;
        closeOnClick?: boolean;
        isWhite?: boolean;
        animate?: boolean;
        isBehindContent?: boolean;
    }): void {
        this._isWhite = options && options.isWhite ? !!options.isWhite : false;
        this._onClick = options ? options.onClick : null;
        this._closeOnClick = options ? !!options.closeOnClick : false;
        this._isBehindContent = options ? !!options.isBehindContent : false;
        this._backdropSubject.next(true);
        this._animate = options ? !!options.animate : false;
        this._isOpen = true;
        document.body.classList.add('block-scroll');
    }

    public closeBackDrop(): void {
        this._isWhite = false;
        this._backdropSubject.next(false);
        this._closeOnClick = false;
        this._isOpen = false;
        document.body.classList.remove('block-scroll');
    }

    public get onClick(): () => void {
        return this._onClick;
    }

    public get isWhite(): boolean {
        return this._isWhite;
    }

    public get closeOnClick(): boolean {
        return this._closeOnClick;
    }

    public get animate(): boolean {
        return this._animate;
    }

    public get isBehindContent(): boolean {
        return this._isBehindContent;
    }

    public get isOpen(): boolean {
        return this._isOpen;
    }
}
